module.exports = __webpack_public_path__ + "e1c22af998212d3a9b64476fb2e06e4e.MP3";